import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Container, Reveal, ImageReveal } from "@/components/Reveal";
import ServiceIcon from "@/components/ServiceIcon";
import { SERVICES } from "@/data/content";

export default function Solutions() {
  return (
    <>
      <SEO
        title="Solutions"
        description="Commercial electricity, natural gas procurement, and Virtual Power Plant Network hosting from Innervation Energy Group."
        path="/solutions"
      />
      <PageHero
        overline="Solutions"
        titleLines={["Commercial energy,", "advised end to end."]}
        subtitle="Three core services — unified by an independent, strategic approach to how your business buys and manages energy."
        crumbs={[{ label: "Solutions", path: "/solutions" }]}
        image={SERVICES[0].image}
      >
        <div className="flex flex-col gap-4 sm:flex-row">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-electric px-8 py-4 text-sm font-medium text-white transition-transform hover:scale-[0.97] hover:bg-electric-hover"
          >
            Contact Us <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </PageHero>

      <section className="bg-white py-24 md:py-32">
        <Container>
          <div className="flex flex-col gap-24 md:gap-32">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug}>
                <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
                  <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                    <ImageReveal
                      src={s.image}
                      alt={s.title}
                      className="aspect-[4/3] border border-line"
                    />
                  </div>
                  <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                    <div className="flex h-12 w-12 items-center justify-center border border-line text-electric">
                      <ServiceIcon name={s.icon} className="h-6 w-6" />
                    </div>
                    <p className="mt-6 font-mono text-xs uppercase tracking-[0.16em] text-slatey">
                      0{i + 1} — Core Service
                    </p>
                    <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-navy md:text-4xl">
                      {s.title}
                    </h2>
                    <p className="mt-5 text-lg leading-relaxed text-slatey">
                      {s.intro}
                    </p>
                    <Link
                      to={`/solutions/${s.slug}`}
                      data-testid={`solutions-learn-${s.slug}`}
                      className="group mt-8 inline-flex items-center gap-2 text-sm font-medium text-electric"
                    >
                      Learn More
                      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <CTABand />
    </>
  );
}
